<template>
  <div id="tower" style="width: 100%; height: 100%"></div>
</template>
<script>
import * as echarts from "echarts";
export default {
  components: {},
  data() {
    return {};
  },
  mounted() {
    var tower = document.getElementById("tower");
    var myEcharts = echarts.init(tower);
    var option = {
      color: ["#5087ec", "#38e9a0","#ebba54"],
      tooltip: {
        trigger: "axis",
      },
      legend: {
        data: ["饲料使用量", "饲料库存量"],
        textStyle: {
          color: "white",
        },
      },
      grid: {
        left: "2%",
        right: "2%",
        bottom: "3%",
        top:"20%",
        containLabel: true,
      },
      calculable: true,
      xAxis: [
        {
          type: "category",
          data: ["1月", "2月", "3月", "4月", "5月","6月","7月"],
          axisLabel: {
            color: "white",
          },
          axisTick: {
            show: false,
          },
          splitLine: {
            show: false,
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: "white",
            },
          },
        },
      ],
      yAxis: [
        {
          type: "value",
          // name: "单位/万",
          axisLabel: {
            color: "white",
            formatter: "{value}吨",
          },
          nameTextStyle: {
            color: "white",
          },
          splitLine: {
            show: true,
            lineStyle: {
              // 在 lineStyle 中设置线的样式
              color: "gray", // 将线的颜色设置为灰色
              opacity: 0.5,
            },
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: "white",
            },
          },
        },
      ],
      series: [
        {
          name: "饲料使用量",
          type: "bar",
          barWidth: "30%",
          barGap: 0,
          data: [135.6, 162.2, 132.6, 150.0, 164,185,175],
          tooltip: {
            valueFormatter: function (value) {
              return value + "吨";
            },
          },
        },
        {
          name: "饲料库存量",
          type: "bar",
          barWidth: "30%",
          data: [75, 84, 58.7, 65, 78,45,52],
          tooltip: {
            valueFormatter: function (value) {
              return value + "吨";
            },
          },
        },
      ],
    };
    myEcharts.setOption(option);
    window.addEventListener("resize", () => {
      myEcharts.resize();
    });
  },
  created() {},
  methods: {},
};
</script>
<style lang="scss" scoped></style>
